import React from 'react';

const Gallery = () => {
    return (
        <div>
            <h3 style={{fontWeight: 'bold', marginRight: '60%', fontSize: "3rem"}}>Our gallery</h3>
       
       <div></div>
       
        </div>
    );
};

export default Gallery;